import { useCallback, useEffect, useRef } from "react";

/**
 * 関数をスロットルし、指定された時間枠内で呼び出せる回数を制限するためのフック。
 */

// biome-ignore lint/suspicious/noExplicitAny: <explanation> 型絞りたいけど、調査できてないので一旦ignore
export function useThrottle<T extends (...args: any[]) => void>(
  callback: T,
  wait: number,
): T {
  const lastCallTimeRef = useRef(0);
  const callbackRef = useRef(callback);

  // callbackの参照を最新に保つ
  useEffect(() => {
    callbackRef.current = callback;
  }, [callback]);

  return useCallback(
    (...args: Parameters<T>) => {
      const now = Date.now();
      if (now - lastCallTimeRef.current >= wait) {
        callbackRef.current(...args);
        lastCallTimeRef.current = now;
      }
    },
    [wait],
  ) as T;
}
